import { Component, Input, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { JobMatchQueryFilter } from 'src/app/core/models/jobMatchQueryFilter';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { JobService } from 'src/app/core/services/job.service';
import { SharedService } from 'src/app/core/services/shared.service';

@Component({
  selector: 'app-send-candidate-outreach-email',
  templateUrl: './send-candidate-outreach-email.component.html',
  styleUrls: ['./send-candidate-outreach-email.component.css']
})
export class SendCandidateOutreachEmailComponent implements OnInit {

  @Input() outreachEmailId;
  @Input() sendOutreachEmail;
  @Input() jobMatches: any[] = [];
  @Input() candidateId;
  @Input() candidateType;
  @Input() companyId;
  @Input() userId;
  @Input() clientOrBuId;
  @Input() context: String;
  @Input() isOutreachModal: boolean = false;
  @Input() vendorIds: number[] = [];
  @Input() salaryDurationOptions;
  @Input() jobTypeList;
  @Output() sendOutreachEmailUpdated = new EventEmitter<any>();
  @Output() closeCallback = new EventEmitter<void>();
  @Output() successCallback = new EventEmitter<any>();

  selectAllJobMatches: boolean = false;
  source: string = 'CANDIDATE_CARD';
  loadingFlag: boolean = true;
  isVendorOnly: boolean = false;
  currentJobMatches: any[] = [];
  hasJobMatches: boolean = false;
  jobMatchId: any;
  constructor(
    private authService: AuthService,
    private candidateService: CandidateService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private jobMatchService: JobMatchService,
    private companyService: CompanyService,
    @Inject('$state') private $state:any,
    private sharedService: SharedService,
    private jobService: JobService
  ) { }

  ngOnInit() {
    this.userId = !this.userId ? this.authService.getUserDetails().id : this.userId;
    this.companyId = !this.companyId ? this.authService.getUserDetails().company.companyId : this.companyId;
    if (!this.clientOrBuId) {
      this.clientOrBuId =
      this.context === 'candidatePossibleJobMatches'
        ? this.clientOrBuId
        : (this.jobMatches && this.jobMatches[0] && this.jobMatches[0].clientOrBuId)
          ? this.jobMatches[0].clientOrBuId
          : '';
    }
    this.isVendorOnly = this.companyService.isCompanyVendor();
    if (this.context == 'candidateCurrentJobMatches' || this.context == 'candidatePossibleJobMatches' || this.context == 'associateCandidates') {
      this.source = 'CANDIDATE_CARD';
      this.jobMatchId = "";
    } else if (this.context == 'candidateJobMatchCard') {
      this.source = 'CANDIDATE_WORKFLOW';
      this.jobMatchId = this.jobMatches[0].jobMatchId;
    } else if (this.context == 'candidateWorkflow') {
      this.source = 'JOBMATCH_CARD';
      this.jobMatchId = this.jobMatches[0].jobMatchId;
    }

    if (!this.isOutreachModal) {
      this.loadingFlag = false;
      this.hasJobMatches = this.jobMatches.some(j => !j.outreachDisabled);
    } else {
      this.loadingFlag = true;
      let count = 0;
      let maxCount = 3;

      const done = () => {
        count++;
        if (count === maxCount) {
          this.loadingFlag = false;
        }
      };
      if (this.salaryDurationOptions && this.salaryDurationOptions.length > 0) {
        done();
      } else {
        this.getAllPreferredJobTypes(done);
      }

      if (this.jobTypeList && this.jobTypeList.length > 0) {
        done();
      } else {
        this.getSalaryDurationOptions(done);
      }

      this.getCandidateJobMatches(() => {
        done();
        if (this.jobMatches && this.jobMatches.length > 0) {
          this.jobMatches = [
            ...this.currentJobMatches.map(current => {

              const previouslyActive = this.jobMatches.some(
                j => j.outreachActiveJob === true && j.jobId === current.jobId
              );

              const isActiveJob = this.jobMatches.some(
                j => j.activeJobId === current.jobId
              );

              if (previouslyActive || isActiveJob) {
                current.outreachActiveJob = true;
              } else {
                current.outreachActiveJob = false;
              }

              return current;
            })
          ];
        } else {
          this.jobMatches = [...this.currentJobMatches];
        }
        this.hasJobMatches = this.jobMatches.some(j => !j.outreachDisabled);
      });
    }
  }

  getCandidateJobMatches(successCallback) {
    let jobMatchesObject = new JobMatchQueryFilter();
    jobMatchesObject.candidateId = this.candidateId;
    jobMatchesObject.userId = this.authService.getUserDetails().id;
    jobMatchesObject.companyId = this.authService.getUserDetails().company.companyId;
    jobMatchesObject.top5Flag = false;
    jobMatchesObject.candidateType = this.candidateType;
    jobMatchesObject.searchText = '';
    jobMatchesObject.vendorIds = this.vendorIds ? this.vendorIds : [];
    this.jobMatchService.getDetailedCandidateJobMatches(jobMatchesObject, this.companyId, 1, 250, (data) => {
      this._massageJobMatches(data);
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _massageJobMatches(data) {
    this.currentJobMatches = [];

    data.forEach((jobMatch) => {
      let outreachState = jobMatch.candidateJobMatchCardDetails ? jobMatch.candidateJobMatchCardDetails.outreachState : '';
      if (outreachState && outreachState != '') {
        jobMatch.outreachIconStatus = this.sharedService.setOutreachIconStatus(outreachState);
      }

      jobMatch.jobMatchStep = jobMatch.currentState ? jobMatch.currentState : (jobMatch.candidateJobMatchCardDetails ? jobMatch.candidateJobMatchCardDetails.jobMatchCurrentState : '-');

      if ((
          (jobMatch.currentState && jobMatch.currentState == 'Released') || 
          (jobMatch.candidateJobMatchCardDetails && jobMatch.candidateJobMatchCardDetails.jobMatchCurrentState == 'Released')
        ) || (
          (jobMatch.currentState && jobMatch.currentState == 'Not Interested') || 
          (jobMatch.candidateJobMatchCardDetails && jobMatch.candidateJobMatchCardDetails.jobMatchCurrentState == 'Not Interested')
        )) {
        jobMatch.outreachDisabled = true;
      }

      if (!this.isVendorOnly && !jobMatch.jobMatchDisabled) {
        jobMatch.jobMatchSelected = false;
        jobMatch.requisitionNumber = jobMatch.candidateJobMatchCardDetails.jobMatchRequisitionNum;
        jobMatch.jobLocationText = this.jobMatchService.setJobLocationText(jobMatch.jobLocation);
        this.currentJobMatches.push(jobMatch);
      }
    });

  }

  isSendOutreachEmailChange() {
    this.sendOutreachEmailUpdated.emit(this.sendOutreachEmail);
  }

  toggleSelectAllJobMatches() {
    if (this.jobMatches && this.jobMatches.length > 0) {
      this.jobMatches.forEach(jobMatch => {
        jobMatch.jobMatchSelected = !jobMatch.outreachDisabled ? this.selectAllJobMatches : false;
      });
    }
  }

  sendSelectedJobMatchOutreachEmail() {
    const selectedJobMatches = this.jobMatches.filter(jobMatch => (jobMatch.jobMatchSelected && !jobMatch.outreachDisabled));
    if (selectedJobMatches.length === 0) {
      this.alertsAndNotificationsService.showAlert('No Selection', 'Please select at least One Job Match to Send Outreach to Candidate.', 'warning');
      return;
    } else {
      let outreachObject = {};
      let candidateIds = [
        {
          id: this.candidateId,
          candidateType: this.candidateType,
          source: this.source,
          jobIds: this.jobMatches.filter(jobMatch => (jobMatch.jobMatchSelected && !jobMatch.outreachDisabled)).map(jobMatch => jobMatch.jobId),
          jobMatchId: this.jobMatchId
        }
      ];
      outreachObject = {
        candidates: candidateIds,
        userId: this.userId,
        companyId: this.companyId,
        clientOrBuId: this.clientOrBuId
      }

      this.candidateService.sendOutreachEmail(outreachObject, (data) => {
        this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
        if (this.successCallback) {
          this.successCallback.emit(outreachObject);
        }
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  close() {
    this.closeCallback.emit();
  }

  onJobMatchSelectionChange() {
    // Only consider job matches that are not disabled for outreach
    if (this.jobMatches && this.jobMatches.length > 0) {
      const enabledJobMatches = this.jobMatches.filter(j => !j.outreachDisabled);
      if (enabledJobMatches.length === 0) {
        this.selectAllJobMatches = false;
      } else {
        this.selectAllJobMatches = enabledJobMatches.every(jobMatch => jobMatch.jobMatchSelected === true);
      }
    } else {
      this.selectAllJobMatches = false;
    }
  }

  goToRequisitionsJob(jobMatch) {
    this.close();
    this.$state.go('missioncontrol.requisitions', {
      userParamsObject: {
        requisitionNumber: jobMatch.requisitionNumber
      }
    });
  }

  getSalaryDurationOptions(successCallback) {
    this.jobService.getSalaryDurationOptions((data) => {
      this.salaryDurationOptions = data;
      if (successCallback) {
        successCallback()
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllPreferredJobTypes(successCallback) {
    this.jobService.getAllJobTypes((data) => {
      this.jobTypeList = data;
      if (successCallback) {
        successCallback()
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    })
  }

}
